import dayjs from "dayjs";
import {
  MaterialTransferido,
  OrdenTrabajo,
} from "@/shared/interfaces";
import { EstadosActivacionInstallOTEnumChoice, EstadosOrdenTrabajoEnumChoice } from "@/shared";

interface CalcularHistorialParams {
  ordentrabajo: OrdenTrabajo;
  coordenadasNuevas?: string;
  usuario?: string;
}

// Pura: no muta nada, retorna el array actualizado.
export function calcularHistorialCambiosCoordenadas({
  ordentrabajo,
  coordenadasNuevas,
  usuario,
}: CalcularHistorialParams) {
  if (ordentrabajo?.coordenadas === coordenadasNuevas) {
    return ordentrabajo?.historial_cambios_coordenadas || [];
  }

  const entradaNueva = {
    usuario,
    fecha_cambio: new Date().toISOString(),
    coordenada_anterior: ordentrabajo?.coordenadas,
    coordenada_nueva: coordenadasNuevas,
  };

  return [
    ...(ordentrabajo?.historial_cambios_coordenadas || []),
    entradaNueva,
  ];
}

interface ConstruirPayloadParams {
  data: Record<string, any>;
  ordentrabajo: OrdenTrabajo;
  materialesFiltrados: MaterialTransferido[];
  productosAdicionales: any[];
  isCorrentingData: boolean;
  esBorrador: boolean;
}

// Pura: arma el objeto que se manda al backend. No dispara nada por sí sola.
export function construirPayloadOrdenTrabajo({
  data,
  ordentrabajo,
  materialesFiltrados,
  productosAdicionales,
  isCorrentingData,
  esBorrador,
}: ConstruirPayloadParams) {
  return {
    es_borrador: esBorrador,
    estado_orden_trabajo: esBorrador
      ? undefined
      : isCorrentingData
        ? EstadosOrdenTrabajoEnumChoice.REALIZADA_ACTUALIZADA
        : EstadosOrdenTrabajoEnumChoice.REALIZADA,
    finalizar_materiales: esBorrador ? undefined : true,
    finalizar_equipos: esBorrador ? undefined : true,

    codigo_bobina: data.codigo_bobina,
    splitter: data.splitter,
    manga: data.manga,
    color_hilo: data.color_hilo,
    num_hilo: data.num_hilo,
    nap: data.nap,
    puerto: data.puerto,
    distancia: data.distancia,
    test_5g: data.test_5g,
    potencia_dbm: data.potencia_dbm,
    potencia_ont: data.potencia_ont,
    es_conexion_tierra: data.es_conexion_tierra,
    es_regulador: data.es_regulador,
    ubicacion_equipo_ac: data.ubicacion_equipo_ac,
    ubicacion_ont: data.ubicacion_ont,
    celular_2: data.celular_2,
    email: data.email,
    persona_referencia_nombre: data.persona_referencia_nombre,
    persona_referencia_celular: data.persona_referencia_celular,
    persona_referencia_celular_2: data.persona_referencia_celular_2,
    persona_referencia_parentesco: data.persona_referencia_parentesco,
    incidencia: data.incidencia,
    prioridad_incidencia: data.prioridad_incidencia,
    observaciones: {
      ...ordentrabajo?.observaciones,
      observacion_tecnico: data.observacion_tecnico,
      observacion_incidencia: data.observacion_incidencia,
    },
    punta_final: "0",

    equipos_utilizados: data?.equipos_utilizados,
    materiales_utilizados: materialesFiltrados,
    materiales_equipos_adicionales: productosAdicionales,
    routers_adicionales_instalados: data?.routers_adicionales_instalados,
    puntos_red_instalados: data?.puntos_red_instalados,
    puntos_red_no_instalados: data?.puntos_red_no_instalados,
    historial_cambios_coordenadas: data?.historial_cambios_coordenadas || [],
    coordenadas: data?.coordenadas,
    fecha_hora_fin_instalacion:
      ordentrabajo?.estado_activacion === EstadosActivacionInstallOTEnumChoice.GESTIONADA
        ? dayjs().toISOString()
        : undefined,
  };
}